import { Injectable } from '@angular/core';
import { NameValue, PersonDto } from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FlightHistoryEdit } from './detailed-flight-history/flight-history-edit.component';
import {
    ManualFlightSummary,
    RpaModelSummary
} from './detailed-flight-history/interfaces';

@Injectable()
export class FlightHistoryDialoguesService {
    constructor(private modalService: BsModalService) {}

    showAddFlightHistoryEdit(
        currentlyEditing: ManualFlightSummary,
        rpaTypeList: RpaModelSummary[],
        rpaCategoryList: NameValue[],
        timeTypes: NameValue[],
        sightTypes: NameValue[],
        currentUser: PersonDto,
        currentlyEditingId: number,
        managingOrganisationId: number
    ) {
        return this.modalService.show(FlightHistoryEdit, {
            ...MODAL_OPTIONS,
            class: 'modal-task modal-md',
            initialState: {
                currentlyEditing,
                rpaTypeList,
                rpaCategoryList,
                timeTypes,
                sightTypes,
                currentUser,
                currentlyEditingId,
                managingOrganisationId
            }
        });
    }
}
